const MessageSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M5.09922 6.59998L3.69922 7.99998L5.09922 9.39998"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6992 6.59998L12.0992 7.99998L10.6992 9.39998"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.89844 15C11.7644 15 14.8984 11.866 14.8984 8C14.8984 4.134 11.7644 1 7.89844 1C4.03244 1 0.898438 4.134 0.898438 8C0.898438 11.866 4.03244 15 7.89844 15Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.59922 6.3689L7.19922 9.63095L8.59922 6.3689Z" fill={color} />
      <path
        d="M8.59922 6.3689L7.19922 9.63095"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MessageSVG;
